import 'portalConfig';

export default angular.module('gw-portals-questionsets-angular', ['portal.config']);